import React, { useState } from 'react';

const CartSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      {/* Cart Icon */}
      <i 
        className="fa-solid fa-cart-shopping" 
        style={{ fontSize: "larger", cursor: "pointer" }} 
        onClick={toggleSidebar}
      ></i>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar}>Close ×</button>
        <h2>Your Cart</h2>
        {/* Add cart items here */}
      </div>

      {/* Overlay (optional) */}
      {isOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </div>
  );
};

export default CartSidebar;
